import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=556a0aa2&scoped=true"
import script from "./UnderConstruction.vue?vue&type=script&lang=js"
export * from "./UnderConstruction.vue?vue&type=script&lang=js"
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&id=556a0aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a0aa2",
  null
  
)

export default component.exports